import React from 'react';
import styled from 'styled-components';
import { COLORS } from '../settings/variables/Colors';

const StyledDiv = styled.div<{ size: number }>`
  border-radius: 50%;
  position: relative;
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  svg {
    top: 0;
    left: 0;
    position: absolute;
  }
  .svg-middle-component {
    top: 50%;
    left: 50%;
    position: absolute;
    transform: translate(-50%, -50%);
  }
`;

interface TrueImpactCircleProgressProps {
  budget: number;
  total: number;
  size?: number;
  className?: string;
  borderWidth?: number;
  middleComponent: JSX.Element;
  backgroundColor?: keyof typeof COLORS;
  foregroundColor?: keyof typeof COLORS;
}

const TrueImpactCircleProgress: React.FC<TrueImpactCircleProgressProps> = ({
  budget,
  total,
  size = 180,
  className,
  middleComponent,
  borderWidth = 12,
  foregroundColor = 'highlight',
  backgroundColor = 'highlightBackground',
}) => {
  const length = size / 2;
  const radius = length - borderWidth / 2;
  const circumference = 2 * Math.PI * radius;
  const rotation = `rotate(-90 ${length} ${length})`;
  const percentage = Math.min(100, (budget / total) * 100);
  const offset = circumference - (percentage / 100) * circumference;

  return (
    <StyledDiv size={size} className={className}>
      <svg width={size} height={size}>
        <circle
          cx={length}
          cy={length}
          r={radius}
          stroke={COLORS[backgroundColor]}
          strokeWidth={borderWidth}
          fill="none"
        />
        <circle
          cx={length}
          cy={length}
          r={radius}
          stroke={COLORS[foregroundColor]}
          strokeWidth={borderWidth}
          fill="none"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          transform={rotation}
        />
      </svg>
      <div className="svg-middle-component">{middleComponent}</div>
    </StyledDiv>
  );
};

export default TrueImpactCircleProgress;
